import {AppState} from "../app";
import {Pointer} from "../engine/tools/InputManager";
import {clamp} from "../engine/utils/math";


export function updateCanvas({interactiveCanvas}: AppState) {

    const {ctx, camera, input} = interactiveCanvas

    interactiveCanvas.autoResize()

    const pixelRatio = window.devicePixelRatio
    const imageSize = 300
    const paddingHorizontal = 28
    const paddingVertical = 110

    const inset = 20 * pixelRatio
    const xMultiplier = (interactiveCanvas.canvas.width - inset) / (imageSize + paddingHorizontal)
    const yMultiplier = (interactiveCanvas.canvas.height - inset) / (imageSize + paddingVertical)
    const baseMultiplier = Math.floor(Math.min(xMultiplier, yMultiplier))
    const multiplier = clamp(baseMultiplier, 1, 2 * pixelRatio)

    interactiveCanvas.camera.visibleHeight = interactiveCanvas.canvas.height / multiplier;

    camera.update(ctx)
}

function fit(interactiveCanvas, width, height) {
    const aspect = width / height;
    const canvasAspect = interactiveCanvas.canvas.width / interactiveCanvas.canvas.height;
    const relativeAspect = aspect / canvasAspect;
    if (relativeAspect > 1)
        interactiveCanvas.camera.visibleHeight = height * relativeAspect;
    else
        interactiveCanvas.camera.visibleHeight = height;
}


function cover(interactiveCanvas, width, height) {
    const aspect = width / height;
    const canvasAspect = interactiveCanvas.canvas.width / interactiveCanvas.canvas.height;
    const relativeAspect = aspect / canvasAspect;
    if (relativeAspect > 1)
        interactiveCanvas.camera.visibleHeight = height;
    else
        interactiveCanvas.camera.visibleHeight = height * relativeAspect;

}

